/* Returning-user heuristic.
 *
 * The header's primary CTA routes new visitors into the sales funnel
 * (/pay) and known account holders straight to the embedded app (/app).
 * "Known" is a persistent localStorage flag set whenever the visitor
 * demonstrably has an account:
 *
 *   - they reach the app embed at /app (bookmark, post-payment ?token=
 *     redirect, or the "you already have access" link)
 *   - the /pay email check comes back has_access
 *   - a card-less trial signup succeeds (offer v2)
 *
 * Deliberately frontend-only and per-browser: an existing learner on a
 * fresh device sees "Start Learning" until they're recognised once.
 * A real cross-device session check (auth cookie on .saysomethingin.com
 * or GET /membership/session) can replace hasAccount() later without
 * touching the header UI.
 */

const KEY = 'ssi_has_account';

export function markHasAccount() {
  try { localStorage.setItem(KEY, '1'); } catch (e) { /* storage unavailable */ }
}

export function hasAccount() {
  try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
}
